import script from "./SettingsNavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsNavItem.vue?vue&type=script&setup=true&lang=js"

import "./SettingsNavItem.vue?vue&type=style&index=0&id=248aff80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-248aff80"]])

export default __exports__